const ResourceType = Object.freeze({
  UNRESTRICTED_NUMBER: 1,
  USERS: 2,
  GROUPS: 3,
  TIMETABLES: 4,
  AUDIO: 5,
  VOICEMAILS: 6,
  QUEUES: 7,
  IVRS: 8,
  QUEUE_LOGIN: 9,
  QUEUE_PAUSE: 10,
  CUSTOM_DESTINATIONS: 11,
  CONFERENCES: 12,
  CALL_PARKINGS: 13,
  INTERCOMS: 14,
  DAY_NIGHTS: 15,
  DAY_NIGHT_TOGGLES: 16,
  MOBILE_USERS: 17,
});

export default ResourceType;
